import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import MDTypography from "components/MDTypography";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function PasswordInput({ onChange, label = "Password", ownerState }) {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const displayErrorMessage = ownerState?.error && ownerState?.helperText;

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel htmlFor="outlined-adornment-password" sx={{ ml: "-14px" }}>
        {label}
      </InputLabel>
      <Input
        id="outlined-adornment-password"
        type={showPassword ? "text" : "password"}
        endAdornment={
          <InputAdornment position="end" sx={{ pr: "16px" }}>
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label="Password"
        onChange={onChange}
      />
      {displayErrorMessage && (
        <MDTypography variant="p" fontWeight="light" color="error" fontSize="12px" mt={1}>
          {ownerState.helperText}
        </MDTypography>
      )}
    </FormControl>
  );
}
